// extracted by mini-css-extract-plugin
export var container = "ContentContainer-module--container--drBKE";